import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import SurveyRequestEntry from "./surveyRequestEntry";

const SurveyRequestEntryPage = () => {
  return (
    <NavHeightAdjust>
      <SurveyRequestEntry />
    </NavHeightAdjust>
  );
};

export default SurveyRequestEntryPage;
